import { createSelector } from 'reselect';
import { parse as parseQueryString } from 'query-string';
import { getQueryString } from './routerGetters';

export const getQueryParams = createSelector(getQueryString, parseQueryString);
